/**
 * Same algorithm as apps/api/src/lib/israeli-id.ts. Duplicated here because
 * the web bundle can't import from the api package without dragging in
 * server-only deps. If divergence ever becomes a problem, move to
 * @lexcrm/shared and import in both.
 */

export type IdValidation =
  | { valid: true }
  | { valid: false; reason: 'empty' | 'too_short' | 'too_long' | 'checksum' };

export function validateIsraeliId(input: string): IdValidation {
  const digits = input.replace(/\D/g, '');
  if (digits.length === 0) return { valid: false, reason: 'empty' };
  if (digits.length > 9) return { valid: false, reason: 'too_long' };
  if (digits.length < 5) return { valid: false, reason: 'too_short' };
  const padded = digits.padStart(9, '0');

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let n = Number(padded[i]) * ((i % 2) + 1);
    if (n > 9) n -= 9;
    sum += n;
  }
  return sum % 10 === 0 ? { valid: true } : { valid: false, reason: 'checksum' };
}

export function validateCompanyNumber(input: string): IdValidation {
  const digits = input.replace(/\D/g, '');
  if (digits.length === 0) return { valid: false, reason: 'empty' };
  if (digits.length > 9) return { valid: false, reason: 'too_long' };
  if (digits.length < 9) return { valid: false, reason: 'too_short' };
  return { valid: true };
}

// Validation reason → translation key suffix. Consumers use
// `t('clients:id_validation.<reason>')` to render the label.
